import { Config } from "final-form";

import { Product } from "@products/types";

const defaultAndroidVersion = "14";

const generateCodeName = (string: string) => {
    if (!string) {
        return "";
    }
    return string
        .replaceAll(" ", "_")
        .replaceAll(/[^0-9a-zA-Z_]+/g, "")
        .toLowerCase();
};

export const getInitialValues = (product: Product | undefined, workspaceId: number | undefined): Product => {
    if (!product) {
        return {
            id: 0,
            workspaceId: workspaceId || 0,
            isPublic: false,
            groupId: null,
            codename: "",
            androidVersion: defaultAndroidVersion,
            nightlyPeriod: 0,
            changes: null,
            visibility: [],
            customBuildConfig: {
                productName: "",
                rootDevice: "caas",
                modules: [],
                sources: {},
                manifest: { projects: [] },
                provisioningId: null,
                buildVariant: "user",
                uiSettings: {
                    headlessMode: "no",
                    kioskMode: "no",
                },
                compatibility: `>=${defaultAndroidVersion}`,
            },
            actionFeatures: ["Build"],
        };
    }
    return {
        ...product,
        workspaceId: product.workspaceId || workspaceId || 0,
        codename: product.codename || generateCodeName(product.customBuildConfig?.productName ?? ""),
        isPublic: product.isPublic,
        actionFeatures: product.actionFeatures || ["Build"],
    };
};

export const mutators: Config<Product>["mutators"] = {
    setTouched: ([fieldName]: string[], state) => {
        if (state.fields[fieldName]) {
            state.fields[fieldName].touched = true;
        }
    },
    setUnTouched: ([fieldName]: string[], state) => {
        if (state.fields[fieldName]) {
            state.fields[fieldName].touched = false;
        }
    },
};
